import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const renameStacklet = (id: number, name: string): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { name, action: 'rename' },
  });
